/**
 * 隐私追踪灰度控制（与 consent 能力解耦，2026-09-12 抽出）。
 * 能力实现（consent 判定 / 匿名净化 / 撤回清理）在 platform/shopify/consentGate.js，
 * 不感知名单；本模块只回答一件事：当前店铺是否启用该能力。
 *
 * 快速操作口径：
 * - 扩灰度：CONSENT_ROLLOUT_COMPANY_IDS 加 companyId（本文件一处）。镜像同步：
 *   react-plugin src/utils/shopify/consentRollout.ts 的 CONSENT_ROLLOUT_UUIDS 加对应
 *   companyUUID（查 t_company）。
 * - 全量放开：CONSENT_ROLLOUT_MODE 改 'all'——前置条件：先上 cm=0 反向退出阀
 *   （shopifyapp liquid else 拼 &cm=0 + 两 SDK 识别 cm=0 解除武装），否则全量下
 *   SDK 静默类缺陷无阀门可拦（marketing 方法名 bug 教训：静默 bug 会被全量放大）。
 */

/** 灰度模式：'whitelist' 白名单灰度 | 'all' 全量（全量前先做 cm=0 退出阀，见头注释） */
var CONSENT_ROLLOUT_MODE = 'whitelist';

/** 灰度店铺（30=allbuy.com；2523=客户店）：未获访客授权前延迟初始化采集、不上报、不自建追踪标识 */
var CONSENT_ROLLOUT_COMPANY_IDS = Object.freeze([30, 2523]);

/** 灰度判定：白名单模式命中列表即启用；全量模式恒启用 */
export function isConsentRolloutEnabled(companyId) {
  if (CONSENT_ROLLOUT_MODE === 'all') return true;
  return CONSENT_ROLLOUT_COMPANY_IDS.includes(Number(companyId));
}
